import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RangeThumbDirective } from './range-thumb/range-thumb.directive';
import { TooltipModule } from '../tooltip/tooltip.module';
import { RangeTrackDirective } from './range-track/range-track.directive';
import { RangeDirective } from './range.directive';
import { RangeBaseDirective } from './range-base/range-base.directive';
import { RangeComponent } from './range.component';
import { RangeBaseMultiDirective } from './range-base-multi/range-base-multi.directive';
import { RangeMultiComponent } from './range-multi.component';

@NgModule({
  declarations: [
    RangeThumbDirective,
    RangeTrackDirective,
    RangeDirective,
    RangeBaseDirective,
    RangeBaseMultiDirective,
    RangeComponent,
    RangeMultiComponent,
  ],
  imports: [CommonModule, FormsModule, TooltipModule],
  exports: [
    RangeThumbDirective,
    RangeTrackDirective,
    RangeDirective,
    RangeBaseDirective,
    RangeBaseMultiDirective,
    RangeComponent,
    RangeMultiComponent,
  ],
})
export class RangeModule {}
